export default function DataTable({ columns, rows, empty }) {
  if (!rows.length) return empty;

  return (
    <>
      <div className="table-wrap" role="region" aria-label="Data table" tabIndex={0}>
        <table className="data-table">
          <caption className="sr-only">Scrollable data table</caption>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={row.id || index}>
              {columns.map((col) => (
                <td key={col.key}>{col.render ? col.render(row) : row[col.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
        </table>
      </div>
      <div className="table-scroll-hint">Scroll horizontally to view all columns.</div>
    </>
  );
}
